var exports = {
  "Qs": "RecipientList.module__content___dDh0cz",
  "Rt": "RecipientList.module__searchInput___dDh0cz",
  "qc": "RecipientList.module__searchIcon___dDh0cz",
  "qI": "RecipientList.module__listContainer___dDh0cz",
  "XG": "RecipientList.module__scroller___dDh0cz",
  "wV": "RecipientList.module__noResults___dDh0cz",
  "PR": "RecipientList.module__friendList___dDh0cz",
  "eH": "RecipientList.module__friendItem___dDh0cz",
  "j8": "RecipientList.module__friendItemLeft___dDh0cz",
  "Hb": "RecipientList.module__friendInfo___dDh0cz",
  "G3": "RecipientList.module__friendName___dDh0cz",
  "hw": "RecipientList.module__friendSecondary___dDh0cz",
  "hP": "RecipientList.module__actionButton___dDh0cz",
};

module.exports = exports;
